"use client";

import { type Address } from "viem";

import { useAccount } from "#/store/wallet/account/account";
import { useEoa } from "#/store/wallet/eoa/eoa";

import { useAccounts } from "./useAccounts";

export const useAccountName = (account?: Address, index?: number) => {
  const { eoa } = useEoa();
  const { accounts } = useAccounts();
  const { account: currentAccount } = useAccount();

  const effectiveAccount = account || currentAccount;
  const effectiveIndex =
    index ?? accounts.findIndex((a) => a === effectiveAccount);

  const accountName =
    effectiveAccount === eoa ? "Main Account" : `Sub Account ${effectiveIndex}`;

  return { accountName };
};
